import "./about.css"
import aboutphoto from "../../img/about.jpg"
import { useEffect } from "react"
import { useState } from "react"
function About(){
    const [countone,setcountone]=useState(0);
    const [counttwo,setcounttwo]=useState(0);
    const [countthree,setcountthree]=useState(0);
    const [countfour,setcountfour]=useState(0);
    const [countfive,setcountfive]=useState(0);
    const [countsix,setcountsix]=useState(0);

    let targetone=20;
    let targettwo=80;
    let targetthree=120;
    let targetfour=140;
    let targetfive=180;
    let targetsix=210;

   useEffect(() => {
  let timer = setInterval(() => {
    if (window.scrollY >= 500) {
      setcountone((prev) => (prev >= targetone ? targetone : prev + 1));
      setcounttwo((prev) => (prev >= targettwo ? targettwo : prev + 1));
      setcountthree((prev) => (prev >= targetthree ? targetthree : prev + 1));
      setcountfour((prev) => (prev >= targetfour ? targetfour : prev + 1));
      setcountfive((prev) => (prev >= targetfive ? targetfive : prev + 1));
      setcountsix((prev) => (prev >= targetsix ? targetsix : prev + 1));
    }
  }, 100);

  return () => clearInterval(timer);
}, [targetone, targettwo, targetthree, targetfour, targetfive, targetsix]);

    return(
        <>
        <div className="about">
            <div className="row  align-items-center  ">
                <div className="col-md-6">
                    <div className="image mb-3">
                        <img src={aboutphoto} className="w-100 rounded" alt="" />
                    </div>

                </div>
                <div className="col-md-6">
  <div className="text">
    <h2>About the Center</h2>
    <div className="border-text">
      <p>
        We are a fully integrated medical center dedicated to providing the best 
        healthcare services with the highest possible quality. Our qualified medical 
        team brings extensive experience across various specialties. We believe that 
        healthcare begins with trust, and we continuously strive to create a safe and 
        comfortable treatment environment that prioritizes patients’ health and 
        satisfaction. The center includes multiple clinics and specialties to meet 
        your diverse needs, equipped with the latest medical devices and modern 
        technologies.
      </p>
    </div>
    <div className="static">
        <div className="start">
  <h4>Center Statistics</h4>
        </div>
        <div className="statics">
  <div className="box">
    <i className="fas fa-hospital"></i>
    <h4>{countone}</h4>
    <h5>Medical Departments</h5>
  </div>
  <div className="box">
    <i className="fas fa-user-md"></i>
    <h4>{counttwo}</h4>
    <h5>Specialized Doctors</h5>
  </div>
  <div className="box">
    <i className="fas fa-users"></i>
    <h4>{countthree}</h4>
    <h5>Patients Served</h5>
  </div>
  <div className="box">
    <i className="fas fa-calendar-check"></i>
    <h4>{countfour}</h4>
    <h5>Years of Experience</h5>
  </div>
   <div className="box">
    <i className="fas fa-stethoscope"></i>
    <h4>{countfive}</h4>
    <h5>Specialized Clinics</h5>
  </div>
<div className="box">
    <i className="fas fa-flask"></i>
    <h4>{countsix}</h4>
    <h5>Diagnostic Labs</h5>
  </div>


  

</div>
    </div>
  </div>
</div>
            </div>

        </div>
        </>
    )
}
export default About